export const catalog_matrix = [
  {form_key:'provider_id', catalog_key:'providers'},
  //{form_key:'benefit_id', catalog_key:'benefits'},
  //{form_key:'responsible_id', catalog_key:'none', propname:'users'},
]